import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Tooltip,
} from "@mui/material";
import { People, Gavel, Shield, Badge, Business, MergeType } from "@mui/icons-material";
import Navbar from "../../../globals/components/Navbar";
import { useNavigate } from "react-router-dom";
import {
  DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE,
  isDuplicateAccountsMergeUiEnabled,
} from "../../../globals/utils/duplicateAccountsMergeFeature";

const AdminAccountManagement = () => {
  const navigate = useNavigate();
  const duplicateAccountsMergeEnabled = isDuplicateAccountsMergeUiEnabled();

  const links = [
    [
      {
        name: "Internal Users",
        path: "/vermost_internal_users",
        icon: <People fontSize="large" />,
      },
      {
        name: "Law Firms",
        path: "/vermost_lawfirm_list",
        icon: <Gavel fontSize="large" />,
      },
      {
        name: "Law Firm Users",
        path: "/vermost_law_firm_users",
        icon: <Business fontSize="large" />,
      },
    ],
    [
      {
        name: "Professional Guardians",
        path: "/vermost-professional-guardian-list",
        icon: <Shield fontSize="large" />,
      },
      {
        name: "Legal Service Paralegals",
        path: "/vermost_paralegals_list",
        icon: <Badge fontSize="large" />,
      },
      {
        name: "Duplicate Accounts",
        path: "/vermost_duplicate_accounts",
        icon: <MergeType fontSize="large" />,
        disabled: !duplicateAccountsMergeEnabled,
        disabledHint: DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE,
      },
    ],
  ];

  return (
    <>
      <Navbar />
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" fontWeight={800} mb={4} sx={{ color: 'black' }}>
          Account Management
        </Typography>
        <Grid container spacing={3}>
          {links.flat().map((link, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Tooltip
                title={link.disabled ? link.disabledHint || "" : ""}
                placement="top"
                enterDelay={200}
              >
                <span style={{ display: "block", width: "100%" }}>
                  <Card
                    elevation={3}
                    sx={{
                      borderRadius: 3,
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)',
                      border: '1px solid rgba(37, 99, 235, 0.2)',
                      transition: "all 0.3s ease-in-out",
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                      opacity: link.disabled ? 0.55 : 1,
                      filter: link.disabled ? "grayscale(35%)" : "none",
                      ...(link.disabled
                        ? {}
                        : {
                            "&:hover": {
                              boxShadow: "0 4px 16px rgba(37, 99, 235, 0.15)",
                              background: 'linear-gradient(135deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%)',
                              transform: 'translateY(-2px)',
                              borderColor: 'rgba(37, 99, 235, 0.4)',
                            },
                          }),
                    }}
                  >
                    <CardActionArea
                      onClick={() => {
                        if (!link.disabled) navigate(link.path);
                      }}
                      disabled={Boolean(link.disabled)}
                      sx={{
                        cursor: link.disabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          padding: 3,
                          color: "#333333",
                        }}
                      >
                        {React.cloneElement(link.icon, {
                          style: { color: link.disabled ? "#9ca3af" : "#2563eb" },
                        })}
                        <Typography variant="h6" fontWeight={500} sx={{ color: '#333333' }}>
                          {link.name}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </span>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default AdminAccountManagement;
